import React from 'react'
import { useTranslation } from 'react-i18next'

import { useNavigate } from '@lib/react-router-dom'

import { Body1 } from '@ui/Typography'

import { PlatformInfoDto } from '@model/PlatformInfoDto'
import { PlatformTypeEnum, getPlatformType } from '@model/PlatformTypeEnum'

import { InfoModal } from '@global/modal/InfoModal'

import { usePlatformDownloadLinksData } from './platformsLearnMoreData'

interface MissingAccountModalProps {
  platformInfo: PlatformInfoDto[]
  onClose(): void
}

export const MissingAccountModal: React.FC<MissingAccountModalProps> = (props) => {
  const { platformInfo, onClose } = props

  const { t } = useTranslation()
  const navigate = useNavigate()

  const { webTraderLink } = usePlatformDownloadLinksData(platformInfo)

  const handleAccountClick = () => {
    navigate('/dashboard/traders-room/trading-accounts/new', {
      state: {
        platformType: getPlatformType(PlatformTypeEnum.TickmillTrader),
      },
    })
  }

  const handleWebTraderClick = () => {
    webTraderLink && window.open(webTraderLink, '_blank')
  }

  return (
    <InfoModal
      onCancel={onClose}
      title={t('ToolsPlatforms.Looks Like Youre Missing an Account')}
      renderBody={() => (
        <section className='modal-card-body'>
          <Body1 isParagraph>
            {t('ToolsPlatforms.To access the WebTrader, you need a Tickmill Trader account')}
          </Body1>
        </section>
      )}
      renderFooter={() => (
        <React.Fragment>
          <button onClick={handleAccountClick} type='button' className='button'>
            {t('ToolsPlatforms.Open Account')}
          </button>
          <button onClick={handleWebTraderClick} type='button' className='button'>
            {t('ToolsPlatforms.Open WebTrader')}
          </button>
        </React.Fragment>
      )}
    />
  )
}
